/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cloneDeep from 'lodash/cloneDeep';
import {
  Paper, Typography, Button, TextField, Icon, Checkbox, Grid, withStyles, IconButton, Snackbar,
} from '@material-ui/core';
import get from 'lodash/get';
import set from 'lodash/set';
import { sortBy } from 'lodash';
import withWidth from 'material-ui/utils/withWidth';
import { format, toDate } from 'date-fns';
import CloseIcon from '@material-ui/icons/Close';
import DisplayResources from '../crud/DisplayResources';
import PushNotificationDialog from '../share/PushNotificationDialog';
import {
  resourceFields,
  timeLines,
  userPaginationCount,
  paginationStart,
} from '../../data/Constants';
import { commonResourceStyle, userPageStyle, notificationDialogStyle } from '../../css/style';
import CraverBreadCrumb from '../share/CraverBreadCrumb';
import LoadingBar from '../share/LoadingBar';
import * as types from '../../redux/resource/ResourcesActionTypes';
import * as Functions from '../../utils/Functions';
import SearchableSelect from '../share/SearchableSelect';
import { getSearchableEntities } from '../../domains/Restrictions';
import { getUserFilterParams } from '../../api/users/UserFilterQuery';

const commonStyles = commonResourceStyle();
const styles = userPageStyle();
const pnStyle = notificationDialogStyle();

const notificationScheduledText = Functions.translation('Users.notificationScheduled');
const customersText = Functions.translation('Users.customers');
const customerText = Functions.translation('Users.customer');

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      filteredUsers: [],
      usersCheckbox: [],
      allUsersCheckbox: false,
      totalUserSelected: '',
      notificationDialog: false,
      notificationTitle: '',
      notificationTitleLength: 0,
      notificationBody: '',
      dialogContent: {},
      isDialogWritingMessage: false,
      notificationBodyLength: 0,
      dialogButtonText: '',
      dialogHeight: '590px',
      neverOrderedisChecked: false,
      searchableLastOrderTime: [],
      searchableNoOrderPlacedInPast: [],
      searchableLastOrderedLocation: [],
      searchableHasOrderedCategory: [],
      searchableHasOrderedProduct: [],
      minPoints: null,
      maxPoints: null,
      disableDropdowns: false,
      invalidMinPoints: false,
      invalidMaxPoints: false,
      openSnackbar: false,
    };
  }

  componentDidMount = async () => {
    await this.getUsersResources();
  };

  componentDidUpdate = async (prevProps) => {
    const { apiToken } = this.props;
    if (prevProps.apiToken !== apiToken) {
      await this.getUsersResources();
    }
  }

  getUsersResources = async () => {
    const { actions, loading, apiToken } = this.props;
    if (loading === false || get(this.props, 'location.state.fromCreateAndEditResource')) {
      const queryParams = `users?start=0&count=${userPaginationCount}`;
      await actions.getAllResources(apiToken, queryParams).then(async (res) => {
        this.setState({ totalUserCount: res.response.totalSize });
        //await this.getUserAddresses(res, actions, apiToken);
      });
    }
    let checkboxArrayLength = 0;
    if (this.props.pagination) {
      checkboxArrayLength = this.props.pagination.totalSize;
    }
    const usersCheckboxArray = new Array(checkboxArrayLength).fill(false);
    this.setState({
      filteredUsers: this.props.users,
      usersCheckbox: usersCheckboxArray,
    });

    this.getSearchableCategories(actions, apiToken);
    this.getSearchableProducts(actions, apiToken);
    this.prepSearchableLocations(actions, apiToken);
  };

  handleOpenSnackbar = () => this.setState({ openSnackbar: true })

  handleCloseSnackbar = () => this.setState({ openSnackbar: false })

  prepSearchableLocations(actions, apiToken) {
    actions.getAllResources(apiToken, 'locations')
      .then((res) => {
        const allLocation = [{ label: 'All', value: 0 }];
        const searchableLocations = allLocation.concat(getSearchableEntities(res));
        this.setState({ searchableLocations });
      });
  }

  getSearchableProducts(actions, apiToken) {
    actions.getAllResources(apiToken, 'products')
      .then((res) => {
        let searchableProducts = [];
        if (res.error || !res.response) return searchableProducts;
        res.response.forEach((product) => {
          if (!product.name || !product.id) return;
          const searchableProduct = { label: product.name, value: product.id };
          searchableProducts.push(searchableProduct);
        });
        searchableProducts = sortBy(searchableProducts, ['label', 'value']);
        this.setState({ searchableProducts });
      });
  }

  getSearchableCategories(actions, apiToken) {
    actions.getAllResources(apiToken, 'categories')
      .then((res) => {
        let searchableCategories = [];
        if (res.error || !res.response) return searchableCategories;
        res.response.forEach((category) => {
          if (!category.name || !category.id) return;
          const searchableCategory = { label: category.name, value: category.id };
          searchableCategories.push(searchableCategory);
        });
        searchableCategories = sortBy(searchableCategories, ['label', 'value']);
        this.setState({ searchableCategories });
      });
  }

  onChangeNotification = (event, isMessage) => {
    if (isMessage) {
      this.setState({
        notificationBody: event.target.value,
        notificationBodyLength: event.target.value.length,
      });
    } else {
      this.setState({
        notificationTitle: event.target.value,
        notificationTitleLength: event.target.value.length,
      });
    }
  }

  onOpenNotificationDialog = () => {
    if (this.state.usersCheckbox.every(user => !user)) return;
    const { usersCheckbox } = this.state;
    const totalUserSelected = usersCheckbox.filter(user => user).length;
    const dialogButtonText = 'NEXT';
    this.setState({
      notificationDialog: true,
      notificationTitle: '',
      notificationBody: '',
      isDialogWritingMessage: true,
      notificationBodyLength: 0,
      notificationTitleLength: 0,
      dialogHeight: '590px',
      totalUserSelected,
      dialogButtonText,
    });
  }

  getRecipientCriteria = (query) => {
    const searchParams = new URLSearchParams(query);
    return { keywords: searchParams.get('q'), filter: searchParams.get('filter') };
  }

  /**
   * @param event all the meta info of the onclick action
   * @description
   * onclick button in two different dialogs
   * if click the button in the first dialog, prompt to the second dialog
   * else if click the button in the second dialog, send requests, prompt to success dialog if success
   * else there is an error occur in sending requests, close dialog
   */
  onClickNextInDialog = async (event) => {
    let response = {};

    if (event.target.textContent === 'NEXT') {
      if (!this.state.notificationTitle || !this.state.notificationBody) return;
      const { totalUserSelected } = this.state;
      const dialogSubTitle = 'Are you sure you want to send the message below to';
      const dialogContent = (
        <div style={pnStyle.dialogContentContainer}>
          <Typography style={{ fontFamily: 'Lato', fontSize: '14px' }}>
            {dialogSubTitle}
          </Typography>
          <Typography style={{
            fontFamily: 'Lato', fontSize: '14px', fontWeight: 'bold', marginBottom: '20px',
          }}
          >
            {totalUserSelected === 1 ? `${totalUserSelected} ${customerText}?` : `${totalUserSelected} ${customersText}?`}
          </Typography>
          <TextField
            autoFocus
            disabled
            placeholder="Message Title"
            style={pnStyle.notificationTitleTextBox}
            inputProps={{
              style: {
                fontFamily: 'Lato', textAlign: 'left', padding: '0', marginTop: '10px', color: '#000',
              },
            }}
            InputProps={{ disableUnderline: true }}
            value={this.state.notificationTitle}
          />
          <TextField
            multiline
            disabled
            autoFocus
            placeholder="Write Message Here"
            rows="6"
            style={pnStyle.notificationBodyTextBox}
            inputProps={{ style: { fontFamily: 'Lato', textAlign: 'left', color: '#000' } }}
            InputProps={{ disableUnderline: true }}
            value={this.state.notificationBody}
          />
        </div>
      );
      const dialogButtonText = 'Yes, send push notification';
      this.setState({
        dialogContent,
        dialogButtonText,
        isDialogWritingMessage: false,
      });
    } else {
      response = await this.sendPushNotification();
      const customersTranslation = response.success === 1 ? customerText : customersText;

      if (!response.error) {
        const dialogButtonText = '';
        const dialogContent = (
          <div style={pnStyle.dialogContentContainer}>
            <Icon style={pnStyle.doneIcon}>done</Icon>
            <Typography style={{ fontFamily: 'Lato' }}>
              {notificationScheduledText}
              <span style={{ fontWeight: 'bold' }}>
                {response.success}
              </span>
              {customersTranslation}
            </Typography>
            {
              response.fail > 0
              && (
                <Typography style={{ fontFamily: 'Lato' }}>
                  {'and failed for '}
                  <span style={{ fontWeight: 'bold' }}>
                    {response.fail}
                  </span>
                  {response.fail === 1 ? ' person.' : ' people.'}
                </Typography>
              )
            }
          </div>
        );
        this.setState({
          usersCheckbox: new Array(this.props.pagination.totalSize).fill(false),
          allUsersCheckbox: false,
          dialogHeight: '370px',
          dialogContent,
          dialogButtonText,
          isDialogWritingMessage: false,
        });
      } else {
        this.setState({
          usersCheckbox: new Array(this.props.pagination.totalSize).fill(false),
          allUsersCheckbox: false,
          notificationDialog: false,
        });
      }
    }
  }

  sendPushNotification = async () => {
    const { actions, apiToken } = this.props;
    const { allUsersCheckbox, usersCheckbox, filteredUsers, totalUserSelected } = this.state;
    const { searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
      searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints } = this.state;
    const query = getUserFilterParams(paginationStart, searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
      searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints, totalUserSelected);

    const recipientCriteria = this.getRecipientCriteria(query);
    const message = {
      title: this.state.notificationTitle,
      body: this.state.notificationBody,
    };

    if (recipientCriteria.filter) {
      set(message, 'recipientCriteria.filter', recipientCriteria.filter);
    }
    if (recipientCriteria.keywords) {
      set(message, 'recipientCriteria.keywords', recipientCriteria.keywords);
    }

    let result = {
      error: undefined,
      success: 0,
      fail: 0,
    };

    if (allUsersCheckbox) {
      await actions.sendPushNotification(apiToken, message, 'push_notifications', 'send-all').then((res) => {
        if (res.error) {
          result.error = res.error;
        } else if (res.response && res.response.data) {
          let values = JSON.parse(res.response.data);
          if (values.length > 1) {
            result.success = values[0];
            result.fail = values[1];
          }
        }
      });
    } else {
      const checkedUsers = filteredUsers.filter((user, index) => usersCheckbox[index]);
      const promises = checkedUsers.map(user => actions.sendPushNotification(apiToken, message, 'push_notifications', 'send', user.id));
      const results = await Promise.allSettled(promises);

      results.map((res) => {
        if (res.error) {
          result.error = res.error;
          result.fail = result.fail + 1;
        } else {
          result.success = result.success + 1;
        }
      });

      if (result.success > 0) {
        result.error = undefined;
      }
    }
    return result;
  }


  /**
   * @param event Checkbox onChange event
   * @param selectedIndex index of the changing user checkbox
   */
  onChangeUsersCheckbox = (event, selectedIndex) => {
    const { usersCheckbox, filteredUsers } = this.state;
    let allUsersCheckbox;
    usersCheckbox[selectedIndex] = event.target.checked;
    if (filteredUsers.every((user, index) => usersCheckbox[index])) {
      allUsersCheckbox = true;
    } else {
      allUsersCheckbox = false;
    }
    this.setState({ usersCheckbox, allUsersCheckbox });
  }

  /**
   * @param event Checkbox onChange event
   */
  onChangeAllUsersCheckbox = (event) => {
    const usersCheckbox = new Array(this.props.pagination.totalSize).fill(event.target.checked);
    this.setState({ usersCheckbox, allUsersCheckbox: event.target.checked });
    const totalUserSelected = usersCheckbox.filter(user => user).length;
    this.setState({ totalUserSelected });
    this.handleOpenSnackbar();
  }

  onCloseNotificationDialog = () => {
    this.setState({ notificationDialog: false });
  }

  onClickViewMore = async () => {
    const {
      actions,
      apiToken,
      pagination,
      loading,
    } = this.props;

    const { filteredUsers, searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
      searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints } = this.state;
    const queryParams = getUserFilterParams(filteredUsers.length, searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
      searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints, userPaginationCount);
    
    if (!loading) {
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_REQUESTED);
      await actions.getAllResources(apiToken, queryParams).then(async (res) => {
        //await this.getUserAddresses(res, actions, apiToken);
        this.setState({
          filteredUsers: this.props.users,
          searchText,
        });
      });
      actions.updateLoadingState(types.VIEW_MORE_RESOURCE_SUCCESS);
    }
  }

  onSearchFieldChange = (event) => {
    this.setState({ searchText: event.target.value });
  };

  onTimeFilterChange = (value) => {
    this.setState({ searchableLastOrderTime: [value] });
  };

  onCheckboxClick = () => {
    this.setState({
      neverOrderedisChecked: !this.state.neverOrderedisChecked,
      disableDropdowns: !this.state.disableDropdowns,
      searchableLastOrderTime: [],
      searchableNoOrderPlacedInPast: [],
      searchableLastOrderedLocation: [],
      searchableHasOrderedCategory: [],
      searchableHasOrderedProduct: [],
    });
  }

  onNoOrderFilterChange = (value) => {
    this.setState({ searchableNoOrderPlacedInPast: [value] });
  }

  onChangeLastOrderLocation = (value) => {
    this.setState({ searchableLastOrderedLocation: [value] });
  }

  onChangeCategories = (value) => {
    this.setState({ searchableHasOrderedCategory: value });
  }

  onChangeProducts = (value) => {
    this.setState({ searchableHasOrderedProduct: value });
  }

  onChangeMinPoints = (event) => {
    const newValue = event.target.value;
    if (this.validateNumeric(newValue)) {
      this.setState({ invalidMinPoints: false }, () => this.setState({ minPoints: newValue }));
    } else {
      this.setState({ invalidMinPoints: true });
    }
  }

  onChangeMaxPoints = (event) => {
    const newValue = event.target.value;
    if (this.validateNumeric(newValue)) {
      this.setState({ invalidMaxPoints: false }, () => this.setState({ maxPoints: newValue }));
    } else {
      this.setState({ invalidMaxPoints: true });
    }
  }

  validateNumeric = value => (/^\d+$/.test(value) || value === '') && value <= (2 ** 31) - 1;

  submitOnEnter=(event) => { if (event.key === 'Enter' && !this.state.invalidMaxPoints && !this.state.invalidMinPoints) { this.onApplyChangeClick(); } }

  onApplyChangeClick = async () => {
    let users = this.props.users;
    const { actions, apiToken } = this.props;
    const { searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
      searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints } = this.state;
    const query = getUserFilterParams(paginationStart, searchText, searchableLastOrderTime, searchableNoOrderPlacedInPast, neverOrderedisChecked,
      searchableLastOrderedLocation, searchableHasOrderedCategory, searchableHasOrderedProduct, maxPoints, minPoints, userPaginationCount);

    await actions.getAllResources(apiToken, query).then((res) => {
      if (res.response) {
        users = res.response.userList;
        const usersCheckboxArray = new Array(res.response.totalSize).fill(false);
        this.setState({ usersCheckbox: usersCheckboxArray });
      }
    });
    await this.setState({ filteredUsers: users, searchText });
  };

  /**
   * Using a for-loop because forEach because it is not asynchronous
   * A map also works in this instance, however causes the screen to flash when loading
   */
  getUserAddresses = async (res, actions, apiToken) => {
    const resUsers = res.response.userList;
    for (let i = 0; i < resUsers.length; i++) {
      const user = resUsers[i];
      //await actions.getAllResources(apiToken, 'users', user.id, 'addresses');
    }
  }

  prepareUserAddress = (addresses) => {
    const addressDisplayArray = [];
    addresses.forEach((address, index) => {
      addressDisplayArray.push(
        <div key={address.id}>
          {`${addresses[index].streetAddress || ''}
         - ${addresses[index].unitNumber || ''}
         ${addresses[index].city}
          - ${addresses[index].country || ''}
          ${addresses[index].postalCode || ''}`
          }
        </div>,
      );
    });
    return addressDisplayArray;
  }

  prepareUserTelephone = telephone => `${telephone.substring(0, 3)}-${telephone.substring(3, 6)}-${telephone.substring(6)}`

  prepareUserLastOrder = (lastOrderTime) => {
    const timeStamp = lastOrderTime * 1000;
    const date = toDate(timeStamp);
    const lastOrder = format(date, 'MM/dd/yy - hh:mm a');
    return lastOrder;
  }

  prepareUserRowDisplayValues = (user) => {
    const { addresses, lastOrderTime, telephone } = user;
    if (addresses && addresses.length > 0) {
      user.addresses = this.prepareUserAddress(addresses);
    }
    if (telephone) {
      let telephone = user.telephone.toString();
      user.telephone = this.prepareUserTelephone(telephone);
    }
    if (lastOrderTime) {
      user.lastOrder = this.prepareUserLastOrder(lastOrderTime);
    } else {
      user.lastOrder = '00/00/00 - 00:00 PM';
    }
  };

  render() {
    const {
      actions, loading, apiToken, match, viewMoreLoading, pagination, totalSize, width,
    } = this.props;
    const { resource } = match.params;
    const mutableUsers = cloneDeep(this.state.filteredUsers);
    if (mutableUsers && totalSize > userPaginationCount) {
      mutableUsers.push({ id: 'viewMore', value: 'VIEW MORE' });
    }
    mutableUsers.map(this.prepareUserRowDisplayValues);
    return (
      (loading === true && viewMoreLoading === 0)
        ? <LoadingBar />
        : (
          <div style={commonStyles.container}>
            <div style={commonStyles.resourceHeader}>
              <div style={commonStyles.resourceName}>
                <Typography style={commonStyles.resourceName}>Users</Typography>
              </div>
              <div style={commonStyles.breadcrumbContainer}>
                <CraverBreadCrumb resource={resource} />
              </div>
            </div>
            <Paper style={styles.filterContainer}>
              <Grid
                container
                direction="row"
                justify="center"
                alignItems="stretch"
              >
                <Grid container item xs={1} direction="column" style={styles.filterColumnContainer} spacing={8}>
                  <Grid item xs={12} style={styles.filterRowContainer}>
                    <div style={(Functions.isDeviceView('sm', width)) ? styles.filterTitleContainerMobile : styles.filterTitleContainer}>
                      <Typography style={styles.filterTitle}>FILTER:</Typography>
                    </div>
                  </Grid>
                </Grid>
                <Grid container item xs={4} direction="column" style={styles.filterColumnContainer} spacing={8}>
                  <Grid item xs style={styles.filterRowContainer}>
                    <TextField
                      style={styles.searchBox}
                      InputProps={{ disableUnderline: true }}
                      inputProps={{ placeholder: 'Search' }}
                      onChange={event => this.onSearchFieldChange(event)}
                      defaultValue={this.state.searchText}
                      autoFocus
                      onKeyPress={this.submitOnEnter}
                    />
                  </Grid>
                  <Grid item xs style={styles.filterRowContainer}>
                    <div style={styles.dropdownFilterContainer}>
                      <Typography style={styles.lastOrderLocationFont}>LAST ORDER LOCATION:</Typography>
                      <SearchableSelect
                        controlStyleOverride={styles.searchableControlSingleOverride}
                        clearIndicatorStyleOverride={styles.clearIndicatorOverride}
                        dropdownIndicatorStyleOverride={styles.dropdownIndicatorOverride}
                        isDisabled={this.state.disableDropdowns}
                        options={this.state.searchableLocations}
                        onChange={value => this.onChangeLastOrderLocation(value)}
                        value={this.state.searchableLastOrderedLocation}
                      />
                      </div>
                  </Grid>
                  <Grid item xs style={styles.filterRowContainer}>
                  <div style={styles.pointsSearchBoxContainer}>
                      <Typography style={styles.minPointsFont}>MINIMUM POINTS:</Typography>
                      <TextField
                        style={this.state.invalidMinPoints ? styles.pointsSearchboxError : styles.pointsSearchbox}
                        InputProps={{ disableUnderline: true }}
                        onChange={event => this.onChangeMinPoints(event)}
                        error={this.state.invalidMinPoints}
                        defaultValue={this.state.minPoints}
                        onKeyPress={this.submitOnEnter}
                      />
                      <Typography style={styles.maxPointsFont}>MAXIMUM POINTS:</Typography>
                      <TextField
                        style={this.state.invalidMaxPoints ? styles.pointsSearchboxError : styles.pointsSearchbox}
                        InputProps={{ disableUnderline: true }}
                        onChange={event => this.onChangeMaxPoints(event)}
                        error={this.state.invalidMinPoints}
                        defaultValue={this.state.maxPoints}
                        onKeyPress={this.submitOnEnter}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container item xs={4} direction="column" style={styles.filterColumnContainer} spacing={8}>
                  <Grid item xs style={styles.filterRowContainer}>
                  <div style={styles.dropdownFilterContainer}>
                      <Typography style={styles.lastOrderFont}>LAST ORDER IN THE PAST:</Typography>
                      <SearchableSelect
                        controlStyleOverride={styles.searchableControlSingleOverride}
                        clearIndicatorStyleOverride={styles.clearIndicatorOverride}
                        dropdownIndicatorStyleOverride={styles.dropdownIndicatorOverride}
                        isDisabled={this.state.disableDropdowns}
                        options={timeLines}
                        onChange={value => this.onTimeFilterChange(value)}
                        value={this.state.searchableLastOrderTime}
                      />
                    </div>
                  </Grid>
                  <Grid item xs style={styles.filterRowContainer}>
                    <div style={styles.dropdownFilterContainer}>
                      <Typography style={styles.hasOrderedCategoryFont}>HAS ORDERED (CATEGORY):</Typography>
                      <SearchableSelect
                        controlStyleOverride={styles.searchableControlMultiOverride}
                        multiValueLabelStyleOverride={styles.multiValueLabelOverride}
                        clearIndicatorStyleOverride={styles.clearIndicatorOverride}
                        dropdownIndicatorStyleOverride={styles.dropdownIndicatorOverride}
                        isMulti
                        isDisabled={this.state.disableDropdowns}
                        options={this.state.searchableCategories}
                        onChange={value => this.onChangeCategories(value)}
                        value={this.state.searchableHasOrderedCategory}
                      />
                    </div>
                  </Grid>
                  <Grid item xs style={styles.filterRowContainer}>
                    <div style={styles.dropdownFilterContainer}>
                      <Typography style={styles.hasOrderedProductFont}>HAS ORDERED (PRODUCT):</Typography>
                      <SearchableSelect
                        controlStyleOverride={styles.searchableControlMultiOverride}
                        multiValueLabelStyleOverride={styles.multiValueLabelOverride}
                        clearIndicatorStyleOverride={styles.clearIndicatorOverride}
                        dropdownIndicatorStyleOverride={styles.dropdownIndicatorOverride}
                        isMulti
                        isDisabled={this.state.disableDropdowns}
                        options={this.state.searchableProducts}
                        onChange={value => this.onChangeProducts(value)}
                        value={this.state.searchableHasOrderedProduct}
                      />
                    </div>
                  </Grid>
                </Grid>
                <Grid container item xs={3} direction="column" style={styles.filterColumnContainer} spacing={8}>
                  <Grid item xs style={styles.filterRowContainer}>
                  <div style={styles.dropdownFilterContainer}>
                      <Typography style={styles.noOrderFont}>NO ORDER PLACED IN THE PAST:</Typography>
                      <SearchableSelect
                        isDisabled={this.state.disableDropdowns}
                        clearIndicatorStyleOverride={styles.clearIndicatorOverride}
                        dropdownIndicatorStyleOverride={styles.dropdownIndicatorOverride}
                        options={timeLines}
                        onChange={value => this.onNoOrderFilterChange(value)}
                        value={this.state.searchableNoOrderPlacedInPast}
                      />
                      </div>
                  </Grid>
                  <Grid item xs style={styles.filterRowContainer}>
                  <div style={styles.neverOrderedContainer}>
                      <Typography style={styles.neverOrderedFont}>NEVER ORDERED:</Typography>
                      <Checkbox
                        checked={this.state.neverOrderedisChecked}
                        color="primary"
                        onChange={() => this.onCheckboxClick()}
                      />
                    </div>
                  </Grid>
                  <Grid item xs style={styles.filterRowContainer}>
                  <div style={styles.applyFilterButtonContainer}>
                      <Button
                        style={styles.applyFilterButton}
                        disabled={this.state.invalidMaxPoints || this.state.invalidMinPoints}
                        onClick={() => this.onApplyChangeClick()}
                      >
                        APPLY
                      </Button>
                  </div>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
            <Paper style={styles.paper}>
              <DisplayResources
                data={mutableUsers}
                actions={actions}
                fieldNames={resourceFields.users}
                resourceName="users"
                buttonArray={[]}
                viewOnly
                isTablet={Functions.isDeviceView('md', width)}
                apiToken={apiToken}
                onClickViewMore={this.onClickViewMore}
                totalResource={pagination && pagination.totalSize}
                viewMoreLoading={viewMoreLoading}
                usersCheckbox={this.state.usersCheckbox}
                allUsersCheckbox={this.state.allUsersCheckbox}
                onChangeUsersCheckbox={this.onChangeUsersCheckbox}
                onOpenNotificationDialog={this.onOpenNotificationDialog}
                onChangeAllUsersCheckbox={this.onChangeAllUsersCheckbox}
              />
              <Snackbar
                autoHideDuration={5000}
                onClose={this.handleCloseSnackbar}
                severity='info'
                open={this.state.openSnackbar}
                message={`Users Selected: ${this.state.totalUserSelected}`}
                action={[
                  <IconButton
                    key="close"
                    aria-label="Close"
                    color='inherit'
                    onClick={this.handleCloseSnackbar}
                  >
                    <CloseIcon />
                  </IconButton>,
                ]}
              />

            </Paper>
            {
              this.state.notificationDialog
              && (
                <PushNotificationDialog
                  isDialogOpen={this.state.notificationDialog}
                  dialogHeight={this.state.dialogHeight}
                  onCloseDialog={this.onCloseNotificationDialog}
                  dialogContent={this.state.dialogContent}
                  dialogButtonText={this.state.dialogButtonText}
                  onClickNextInDialog={this.onClickNextInDialog}
                  notificationBodyLength={this.state.notificationBodyLength}
                  notificationTitleLength={this.state.notificationTitleLength}
                  onChangeNotification={this.onChangeNotification}
                  isDialogWritingMessage={this.state.isDialogWritingMessage}
                />
              )
            }
          </div>
        )
    );
  }
}

Users.propTypes = {
  loading: PropTypes.bool.isRequired,
  users: PropTypes.arrayOf(PropTypes.object),
  actions: PropTypes.objectOf(PropTypes.any).isRequired,
  apiToken: PropTypes.string.isRequired,
};

Users.defaultProps = {
  users: null,
};

const sharedStyles = () => ({
  ...commonStyles,
  ...styles,
  ...pnStyle,
});

export default withWidth()(withStyles(sharedStyles)(withRouter(Users)));
